<div class="panel-header-container" [formGroup]="miscRiskTravelCostsFormGroup">
    <div class="panel-header-row">

        <button mat-icon-button (click)="isMRTCostsExpanded = !isMRTCostsExpanded" class="button-expand-collapse">
            <mat-icon class="icon-expand-collapse">
                {{isMRTCostsExpanded ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        <table class="full-width">
            <tr class="custom-table-row">
                <td class="estimate-table-column width-230 justify-content-start">{{ 'MISC_RISK_TRAVEL_COSTS' |
                    translate}}</td>
                <td class="estimate-table-column width-70">
                    {{ miscRiskTravelCostsFormGroup.controls.headerRow.controls.cost.value | multilingualCurrency }}
                </td>
                <td class="estimate-table-column width-70"></td>
                <td class="estimate-table-column width-70">
                    {{ miscRiskTravelCostsFormGroup.controls.headerRow.controls.tdcPercentage.value | decimalPrecision
                    }}%
                </td>
                <td class="estimate-table-column width-70">
                    <ng-container *ngIf=" isMarkUpSelected; else miscHeaderCostsGrossMarginPercentage">
                        {{ miscRiskTravelCostsFormGroup.controls.headerRow.controls.markUpPercentage.value |
                        decimalPrecision }}%
                    </ng-container>
                    <ng-template #miscHeaderCostsGrossMarginPercentage>
                        {{ miscRiskTravelCostsFormGroup.controls.headerRow.controls.grossMarginPercentage.value |
                        decimalPrecision }}%
                    </ng-template>
                </td>
                <td class="estimate-table-column width-210 padding-gm">
                    {{ miscRiskTravelCostsFormGroup.controls.headerRow.controls.grossMargin.value | multilingualCurrency
                    }}
                </td>
                <td class="estimate-table-column width-110">
                    {{ miscRiskTravelCostsFormGroup.controls.headerRow.controls.sellPrice.value | multilingualCurrency
                    }}
                </td>
            </tr>
        </table>
    </div>

    <div *ngIf="isMRTCostsExpanded">
        <div class="table-container">
            <table class="full-width">
                @for (rowGroup of mainTableRows; track rowGroup) {
                <tr class="material-cost-row"
                    *ngIf="(rowGroup.controls.name.value !== mechanicalFeeRowName || showMechanicalFee) && (rowGroup.controls.name.value !== subcontractorFeeRowName || showSubcontractorFee)"
                    [formGroup]="rowGroup">
                    <td class="estimate-table-column width-190">
                        {{ getRowLabelKey(rowGroup.controls.name.value) | translate}}
                    </td>
                    <td class="estimate-table-column width-110">
                        {{ rowGroup.controls.cost.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70">
                        {{ rowGroup.controls.tdcPercentage.value | decimalPrecision}}%
                    </td>
                    <td class="estimate-table-column width-70">
                        <ng-container *ngIf="isPricingModeLineItem() ; else notLaborRowGroup">
                            <ng-container *ngIf=" isMarkUpSelected; else notMarkUpRowGroup">
                                <mat-form-field appearance="outline"
                                    class="no-padding-input mat-input-alignment width-70 margin-field"
                                    [class.margin-field-changed]="!estimateTab?.[miscRiskTravelSellPriceFlags[rowGroup.controls.name.value]]">
                                    <input matInput
                                        [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig"
                                        inputmode="decimal" formControlName="markUpPercentage"
                                        class="input-alignment" />
                                </mat-form-field>
                            </ng-container>
                            <ng-template #notMarkUpRowGroup>
                                <mat-form-field appearance="outline"
                                    class="no-padding-input mat-input-alignment width-70 margin-field"
                                    [class.margin-field-changed]="!estimateTab?.[miscRiskTravelSellPriceFlags[rowGroup.controls.name.value]]">
                                    <input matInput
                                        [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig"
                                        inputmode="decimal" formControlName="grossMarginPercentage"
                                        class="input-alignment" />
                                </mat-form-field>
                            </ng-template>
                        </ng-container>
                        <ng-template #notLaborRowGroup>
                            <ng-container *ngIf=" isMarkUpSelected; else notMarkUpRowGroup">
                                {{ rowGroup.controls.markUpPercentage.value | decimalPrecision }}%
                            </ng-container>
                            <ng-template #notMarkUpRowGroup>
                                {{ rowGroup.controls.grossMarginPercentage.value | decimalPrecision }}%
                            </ng-template>
                        </ng-template>
                    </td>
                    <td class="estimate-table-column width-210 padding-gm">
                        {{ rowGroup.controls.grossMargin.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-110">
                        <ng-container *ngIf="isPricingModeLineItem() ; else noInputSellPrice">
                            <mat-form-field class="no-padding-input mat-input-alignment width-110" appearance="outline"
                                [class.sell-price-changed]="estimateTab?.[miscRiskTravelSellPriceFlags[rowGroup.controls.name.value]]">
                                <input matInput
                                    [appNumericMask]="solEstimateTableCommonFunctionsService.sellPriceConfig"
                                    [showStepper]="false" inputmode="decimal" formControlName="sellPrice"
                                    class="input-alignment" />
                            </mat-form-field>
                        </ng-container>
                        <ng-template #noInputSellPrice>
                            {{ rowGroup.controls.sellPrice.value | multilingualCurrency }}
                        </ng-template>
                    </td>
                </tr>
                }
            </table>
        </div>

        @if (!isRiskIncludedInPPM) {
        <ng-container formGroupName="riskCosts">
            <div class="risk-cost-row">
                <button mat-icon-button (click)="isRiskCostsExpanded = !isRiskCostsExpanded"
                    class="button-expand-collapse">
                    <mat-icon class="icon-expand-collapse">
                        {{isRiskCostsExpanded ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                </button>
                <table class="full-width">
                    <tr class="custom-table-row">
                        <td class="estimate-table-column risk-cost-label width-190 ps-2">
                            {{ subRiskHeaderRow.controls.name.value | translate}}
                        </td>
                        <td class="estimate-table-column width-110">
                            {{ subRiskHeaderRow.controls.cost.value | multilingualCurrency }}
                        </td>
                        <td class="estimate-table-column width-70"></td>
                        <td class="estimate-table-column width-70">
                            {{ subRiskHeaderRow.controls.tdcPercentage.value | decimalPrecision }}%
                        </td>
                        <td class="estimate-table-column width-70">
                            <ng-container *ngIf=" isMarkUpSelected; else subContractorsCostsGrossMarginPercentage">
                                {{ subRiskHeaderRow.controls.markUpPercentage.value | decimalPrecision }}%
                            </ng-container>
                            <ng-template #subContractorsCostsGrossMarginPercentage>
                                {{ subRiskHeaderRow.controls.grossMarginPercentage.value | decimalPrecision }}%
                            </ng-template>
                        </td>
                        <td class="estimate-table-column width-210 padding-gm">
                            {{ subRiskHeaderRow.controls.grossMargin.value | multilingualCurrency }}
                        </td>
                        <td class="estimate-table-column width-110">
                            {{ subRiskHeaderRow.controls.sellPrice.value | multilingualCurrency }}
                        </td>
                    </tr>
                </table>
            </div>
            <div *ngIf="isRiskCostsExpanded" class="margin-left-28">

                <div class="table-container">
                    <table class="full-width">
                        <tr class="table-row-container" *ngFor="let riskRowGroup of subRiskFormArray.controls;"
                            [formGroup]="riskRowGroup">
                            <ng-container
                                *ngIf="riskRowGroup.controls.name.value === 'CALCULATED_RISK_COSTS'; else notCalculatedRiskCosts">
                                <td class="custom-anchor risk-cost-child-definition" (click)="openRiskDialog()"
                                    [class.collab-sapsub-disabled]="isCollaborativeNotEdit || isEstimateSapSubmitted || isEstimateClosed">
                                    {{ riskRowGroup.controls.name.value | translate}}
                                </td>
                            </ng-container>
                            <ng-template #notCalculatedRiskCosts>
                                <td class="risk-cost-child-definition">
                                    {{ riskRowGroup.controls.name.value | translate}}
                                </td>
                            </ng-template>
                            <td class="estimate-table-column width-110">
                                {{ riskRowGroup.controls.cost.value | multilingualCurrency }}
                            </td>
                            <td class="estimate-table-column width-70"></td>
                            <td class="estimate-table-column width-70">
                                {{ riskRowGroup.controls.tdcPercentage.value | decimalPrecision }}%
                            </td>
                            <td class="estimate-table-column width-70">
                                <ng-container *ngIf="isPricingModeLineItem() ; else notLabor">
                                    <ng-container *ngIf=" isMarkUpSelected; else notMarkUp">
                                        <mat-form-field appearance="outline"
                                            class="no-padding-input mat-input-alignment width-70 margin-field"
                                            [class.margin-field-changed]="!estimateTab?.[riskSellPriceFlags[riskRowGroup.controls.name.value]]">
                                            <input matInput
                                                [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig"
                                                inputmode="decimal" formControlName="markUpPercentage"
                                                class="input-alignment" />
                                        </mat-form-field>
                                    </ng-container>
                                    <ng-template #notMarkUp>
                                        <mat-form-field appearance="outline"
                                            class="no-padding-input mat-input-alignment width-70 margin-field"
                                            [class.margin-field-changed]="!estimateTab?.[riskSellPriceFlags[riskRowGroup.controls.name.value]]">
                                            <input matInput
                                                [appNumericMask]="solEstimateTableCommonFunctionsService.calculatedPercentageConfig"
                                                inputmode="decimal" formControlName="grossMarginPercentage"
                                                class="input-alignment" />
                                        </mat-form-field>
                                    </ng-template>
                                </ng-container>
                                <ng-template #notLabor>
                                    <ng-container *ngIf=" isMarkUpSelected; else notMarkUp">
                                        {{ riskRowGroup.controls.markUpPercentage.value | decimalPrecision }}%
                                    </ng-container>
                                    <ng-template #notMarkUp>
                                        {{ riskRowGroup.controls.grossMarginPercentage.value | decimalPrecision }}%
                                    </ng-template>
                                </ng-template>
                            </td>
                            <td class="estimate-table-column width-210 padding-gm">
                                {{ riskRowGroup.controls.grossMargin.value | multilingualCurrency }}
                            </td>
                            <td class="estimate-table-column width-110">
                                <ng-container *ngIf="isPricingModeLineItem() ; else noInputSellPrice">
                                    <mat-form-field class="no-padding-input mat-input-alignment width-110"
                                        appearance="outline"
                                        [class.sell-price-changed]="estimateTab?.[riskSellPriceFlags[riskRowGroup.controls.name.value]]">
                                        <input matInput
                                            [appNumericMask]="solEstimateTableCommonFunctionsService.sellPriceConfig"
                                            [showStepper]="false" inputmode="decimal" formControlName="sellPrice"
                                            class="input-alignment" />
                                    </mat-form-field>
                                </ng-container>
                                <ng-template #noInputSellPrice>
                                    {{ riskRowGroup.controls.sellPrice.value | multilingualCurrency }}
                                </ng-template>
                            </td>
                        </tr>
                    </table>
                </div>

            </div>
        </ng-container>
        }

    </div>
</div>